export default {
  "login": {
    "媒合平台": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["媒合平台"])},
    "帳號": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帳號"])},
    "密碼": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密碼"])},
    "登入": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登入"])},
    "請輸入帳號": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入帳號"])},
    "請輸入密碼": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入密碼"])},
    "登入成功": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登入成功"])}
  },
  "breadcrumb": {
    "user": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的帳戶"])},
    "order": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查詢訂單"])},
    "point": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["紅利紀錄"])},
    "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更新個人資訊"])},
    "car": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["購物車"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["平台資訊"])},
    "user_knowhow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用者專區"])},
    "product_return": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退換貨須知"])},
    "legal_policy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法律與政策"])},
    "contact_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["社群/聯絡"])},
    "activity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活動"])},
    "win_record": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中獎紀錄"])},
    "redeem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兌換資料"])}
  },
  "pointsDetail": {
    "type1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["贈點"])},
    "type2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扣點"])},
    "type3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["紅包"])},
    "type4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兌換"])},
    "type5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消訂單"])}
  },
  "order": {
    "status1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待收款"])},
    "status2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待交付"])},
    "status3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待確認"])},
    "status4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已完成"])},
    "status9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已取消"])}
  }
}